import { jsx as _jsx } from "react/jsx-runtime";
const MenuListItem = ({ children }) => {
    return (_jsx("li", { className: "flex-grow list-none", role: "none", children: children }));
};
export default MenuListItem;
